export { default } from './configure-component';



// WEBPACK FOOTER //
// ./src/fields/configure/index.js